export const PageNotFound = () => {
    return (
        <>
            Page not found
        </>
    );
}